export const MERGE_TAG_DRAG_TYPE = "application/x-lexical-merge-tag"

/** Stable empty list for editors that never resolve form merge tags (e.g. subject line). */
export const EMPTY_MERGE_TAG_FORMS: { externalId: string; name: string }[] = []
